<template>
  <BaseInputField
    v-bind="$props"
    @input="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    @click="$emit('click', $event)"
    @blur="$emit('blur', $event)"
  >
    <template #suffix>
      <slot name="suffix" />
    </template>
    <template #suffixIcon>
      <slot name="suffixIcon" />
    </template>
  </BaseInputField>
</template>

<script>
import htmlProps from '../htmlProps.js';
import BaseInputField from './BaseInputField.vue';
import commonProps from './common-props-mixin';
import validation from './validation-mixin';

export default {
  name: 'TextField',
  emits: ['change', 'click', 'blur', 'update:modelValue'],
  mixins: [validation, commonProps, htmlProps],
  components: {
    BaseInputField,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/require-default-prop
    modelValue: {
      type: [String, Number],
    },
    // eslint-disable-next-line vue/require-default-prop
    placeholder: {
      type: String,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    autocomplete: {
      type: String,
      default: null,
    },
    pattern: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
};
</script>
